import { forwardRef } from "react";

const EmploymentTypeSelect = forwardRef((props: any, ref: any) => {
  return (
    <select
      {...props}
      ref={ref}
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
      defaultValue="fulltime"
    >
      <option value="fulltime">Vollzeit</option>
      <option value="parttime">Teilzeit</option>
      <option value="other">Anderes</option>
    </select>
  );
});

export default EmploymentTypeSelect;
